import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import LocationMap from '../tools/LocationMap';
import * as ETVConstants from '../ETVConstants';

import {
  Box,
  Chip,
  Grid,
  Paper,
  Stack,
} from '@mui/material';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import ETVPage from '../tools/ETVPage';
import ETVPopup from '../tools/ETVPopup';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';

class WeatherInfo extends React.Component {
  constructor(props) {
    super(props);
    this.selectedScreens = this.selectedScreens.bind(this);
    this.closeScreenSelection = this.closeScreenSelection.bind(this);
    this.setLocationGPS = this.setLocationGPS.bind(this);
  }

  state = {
    cities: [],
    content_format: '4_3',
    info_message: undefined,
    info_title: '',
    info_type: 'info',
    lang: 'en',
    celcius: true,
    channel: '0',
    selected_screens: [],
    window: '',
    override_city_name: '',
    show_date: true,
    use_bg: true,
    lat: '',
    lgt: '',
  };

  resetState() {
    this.setState({
      content_format: '4_3',
      info_message: '',
      info_title: '',
      info_type: 'info',
      lang: 'en',
      celcius: true,
      channel: '0',
      selected_screens: [],
      window: '',
      override_city_name: '',
      show_date: true,
      use_bg: true,
      lat: '',
      lgt: '',
    });
  }

  selectedScreens(screenIDs) {
    this.showWindow('select_screens_div', false);
    this.setState({ selected_screens: screenIDs });
  }

  closeScreenSelection() {
    this.showWindow('select_screens_div', false);
  }

  showWindow(divID, show) {
    show ? this.setState({ window: divID }) : this.setState({ window: '' });
  }

  showInfoMessage(title, msg) {
    this.setState({ window: 'message_div', info_type: 'info', info_title: title, info_message: msg });
  }
  showSuccessMessage(title, msg) {
    this.setState({ window: 'message_div', info_type: 'success', info_title: title, info_message: msg });
  }
  showErrorMessage(title, msg) {
    this.setState({ window: 'message_div', info_type: 'error', info_title: title, info_message: msg });
  }
  closeInfoMessage() {
    this.setState({ info_title: '', info_message: '', window: '' });
  }

  saveWeatherInfo() {
    const desc = 'weather forecast for ' + this.state.override_city_name;
    this.showInfoMessage(ETVConstants.trans('upload'), ETVConstants.trans('uploading...'));

    let url =
      ETVConstants.getServerBase() +
      '/weather_service?action=register_city&lang=' +
      this.state.lang +
      '&user_id=' +
      this.props.user_id;

    url += `&template_path=templates/weather/weather_template_${this.state.content_format}.html`;
    url += `&param_0.name=@@city_name@@&param_0.value=${this.state.override_city_name}`;
    url += `&param_1.name=@@lang@@&param_1.value=${this.state.lang}`;
    url += `&param_2.name=@@celcius@@&param_2.value=${this.state.celcius}`;
    url += `&param_3.name=@@override_city_name@@&param_3.value=${this.state.override_city_name}`;
    url += `&param_4.name=@@lat@@&param_4.value=${this.state.lat}`;
    url += `&param_5.name=@@lgt@@&param_5.value=${this.state.lgt}`;
    url += `&desc=${encodeURIComponent(desc)}`;

    if (this.state.selected_screens && this.state.selected_screens.length > 0) {
      url += `&channel=${this.state.channel}`;
      for (let i = 0; i < this.state.selected_screens.length; i++) {
        url += `&device_id=${this.state.selected_screens[i]}`;
      }
    }

    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        () => {
          this.resetState();
          this.showSuccessMessage('', ETVConstants.trans('the_content_was_stored_in_your_library'));
        },
        () => {
          this.showErrorMessage('error', 'error while uploading');
        }
      );
  }

  setSearchLocation() {
    this.setState({ window: 'search_location_div' });
  }

  setLocationGPS(lat, lgt, cityName) {
    this.setState({ lat: lat, lgt: lgt, override_city_name: cityName, window: '' });
  }

  // ---------- UI ----------
  formatPreview() {
    const { content_format } = this.state;
    const src =
      content_format === '16_9'
        ? '/image_assets/weather/weather_16_9.jpg'
        : content_format === '4_3'
        ? '/image_assets/weather/weather_4_3.jpg'
        : '/image_assets/weather/weather_square.jpg';

    const maxW = content_format === '1_1' ? 220 : 360;

    return (
      <Paper variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
        <Box sx={{ width: '100%', maxWidth: maxW, mx: 'auto', borderRadius: 2, overflow: 'hidden' }}>
          <Box component="img" src={src} alt="preview" sx={{ width: '100%', height: 'auto', display: 'block' }} />
        </Box>
      </Paper>
    );
  }

  render() {
    return (
      <ETVPage width="standard" icon={<CloudOutlinedIcon/>} title={ETVConstants.trans('weather_info')}
        bottomActions={
          <Button disabled={!this.state.lat} startIcon={<UploadFileIcon/>} variant="contained" onClick={() => this.saveWeatherInfo()}>
            {ETVConstants.trans('upload')}
          </Button>
        }>
            {/* Location Row */}
            <Stack spacing={2.5}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', sm: 'center' }}>
                <Button variant="contained" onClick={() => this.setSearchLocation()}>
                  {ETVConstants.trans('set_location')}
                </Button>
                <Chip label={`latitude: ${this.state.lat || '-'}`} size="small" />
                <Chip label={`longitude: ${this.state.lgt || '-'}`} size="small" />
                {this.state.override_city_name && <Chip color="primary" label={this.state.override_city_name} size="small" />}
              </Stack>

              <TextField
                label={ETVConstants.trans('alternative_name_to_be_displayed')}
                inputProps={{ maxLength: 30 }}
                fullWidth
                value={this.state.override_city_name}
                onChange={(e) => this.setState({ override_city_name: e.target.value })}
                helperText={`${this.state.override_city_name.length}/30`}
              />

              <Grid container spacing={3} alignItems="flex-start">
                <Grid item xs={12} sm={6} md={5}>
                  <Stack spacing={2}>
                    <FormControl fullWidth>
                      <InputLabel>{ETVConstants.trans('content_format')}</InputLabel>
                      <Select
                        label={ETVConstants.trans('content_format')}
                        id="content_format"
                        value={this.state.content_format}
                        onChange={(e) => this.setState({ content_format: e.target.value })}
                      >
                        <MenuItem value="16_9">{ETVConstants.trans('16_9')}</MenuItem>
                        <MenuItem value="4_3">{ETVConstants.trans('4_3')}</MenuItem>
                        <MenuItem value="1_1">{ETVConstants.trans('square')}</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>Language</InputLabel>
                      <Select label="Language" id="lang_format" value={this.state.lang} onChange={(e) => this.setState({ lang: e.target.value })}>
                        <MenuItem value="en">English</MenuItem>
                        <MenuItem value="de">German</MenuItem>
                        <MenuItem value="fr">French</MenuItem>
                        <MenuItem value="es">Spanish</MenuItem>
                        <MenuItem value="it">Italian</MenuItem>
                        <MenuItem value="ja">Japanese</MenuItem>
                        <MenuItem value="ko">Korean</MenuItem>
                        <MenuItem value="zh-CN">Chinese (Simplified)</MenuItem>
                        <MenuItem value="zh-TW">Chinese (Traditional)</MenuItem>
                        <MenuItem value="th">Thai</MenuItem>
                        <MenuItem value="vi">Vietnamese</MenuItem>
                        <MenuItem value="ru">Russian</MenuItem>
                        <MenuItem value="ar">Arabic</MenuItem>
                        <MenuItem value="hi">Hindi</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>{ETVConstants.trans('temperature_units')}</InputLabel>
                      <Select
                        label={ETVConstants.trans('temperature_units')}
                        id="temp_units"
                        value={this.state.celcius}
                        onChange={(e) => this.setState({ celcius: e.target.value })}
                      >
                        <MenuItem value={true}>{ETVConstants.trans('celcius')}</MenuItem>
                        <MenuItem value={false}>{ETVConstants.trans('fahrenheit')}</MenuItem>
                      </Select>
                    </FormControl>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={7}>
                  {this.formatPreview()}
                </Grid>
              </Grid>

              <Divider textAlign="left">{ETVConstants.trans('distribution') || 'distribution'}</Divider>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
                <Button variant="contained" onClick={() => this.showWindow('select_screens_div', true)}>
                  {ETVConstants.trans('select_screens')}&nbsp;({this.state.selected_screens?this.state.selected_screens.length:0})
                </Button>

                <FormControl sx={{ minWidth: 180 }}>
                  <InputLabel>{ETVConstants.trans('channel')}</InputLabel>
                  <Select
                    label={ETVConstants.trans('channel')}
                    id="channel_id"
                    size="small"
                    value={this.state.channel}
                    onChange={(e) => {
                      this.setState({ channel: e.target.value });
                    }}
                  >
                    <MenuItem value="0">Channel 0</MenuItem>
                    <MenuItem value="1">Channel 1</MenuItem>
                    <MenuItem value="2">Channel 2</MenuItem>
                    <MenuItem value="3">Channel 3</MenuItem>
                    <MenuItem value="4">Channel 4</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Stack>

        {/* Screen selector overlay */}
        <div id="select_screens_div" style={{ display: this.state.window === 'select_screens_div' ? 'block' : 'none' }}>
          <SelectAvailableScreensNew
            isOpen={this.state.window === 'select_screens_div'}
            user_id={this.props.user_id}
            closeHook={this.closeScreenSelection}
            selectedScreens={this.selectedScreens}
            selected={this.state.selected_screens ? this.state.selected_screens : []}
          />
        </div>

        <ETVMessagePopup
          type={this.state.info_type}
          open={this.state.window === 'message_div'}
          onClose={() => {
            this.resetState();
          }}
          title={this.state.info_title}
          message={this.state.info_message}
        />

        {/* Location picker */}
        <ETVPopup
          open={this.state.window === 'search_location_div'}
          width="wide"
          onClose={() => {
            this.setState({ window: '' });
          }}
          icon={<PlaceOutlinedIcon/>}
          title={ETVConstants.trans('set_location')}
          dialogProps={{disableEnforceFocus:true,disableAutoFocus:true,disableScrollLock:true}}
          bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans('close')} onClick={() => this.setState({window:''})}/>}>
            <LocationMap setLocationGPS={this.setLocationGPS} />
        </ETVPopup>
      </ETVPage>
    );
  }
}

export default WeatherInfo;
